<template>
  <div class="all">
    <div class="midd">
      <el-table ref="multipleTable" :data="tableData" border highlight-current-row height="100%">
        <template slot="empty">
          <img :src="zanwu" alt="" />
          <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
        </template>
        <el-table-column label="序号" type="index" width="60" />
        <el-table-column label="线型名称" prop="lineType" />
        <el-table-column label="线型描述" prop="description" />
        <el-table-column label="线型定义" prop="value" />
        <el-table-column label="备注" prop="remark" />
      </el-table>
    </div>
  </div>
</template>
<script>
import linearStyle from "@/CommonDP/service/lineStyle-service";
import { getEnterpriseId } from "@/CommonDP/utils/auth";
export default {
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      tableData: []
    };
  },
  computed: {
    enterpriseId() {
      return getEnterpriseId("enterpriseId");
    }
  },
  mounted() {
    this.getPersonList();
  },
  methods: {
    // 列表
    getPersonList() {
      this.tableData = [];
      linearStyle.getLinearList(this.enterpriseId).then(({ data }) => {
        this.tableData = data || [];
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.all {
  height: 100%;
  position: relative;
  background-color: #fff;
}
.midd {
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 4px 10px;
}
</style>
